import {
  APPLY_ON_FIXED_PER_PERSON,
  APPLY_ON_ESTIMATED_PER_PERSON,
  APPLY_ON_FIXED_PER_HOUR,
  APPLY_ON_ESTIMATED_PER_HOUR,
  APPLY_ON_FIXED_PER_DAY,
  APPLY_ON_ESTIMATED_PER_DAY,
  APPLY_ON_ESTIMATED,
  COST_TYPE_CUSTOM_FEE,
  COST_TYPE_CUSTOM_SERVICE,
  COST_TYPE_CUSTOM_TAX
} from '../../constants/costs';

export const getUnit = applyOn => {
  if (
    applyOn === APPLY_ON_FIXED_PER_PERSON ||
    applyOn === APPLY_ON_ESTIMATED_PER_PERSON
  ) {
    return 'person';
  }
  if (
    applyOn === APPLY_ON_FIXED_PER_HOUR ||
    applyOn === APPLY_ON_ESTIMATED_PER_HOUR
  ) {
    return 'hour';
  }
  if (
    applyOn === APPLY_ON_FIXED_PER_DAY ||
    applyOn === APPLY_ON_ESTIMATED_PER_DAY
  ) {
    return 'day';
  }
  return null;
};

export const isEstimatedCost = applyOn => {
  return (
    applyOn === APPLY_ON_ESTIMATED ||
    applyOn === APPLY_ON_ESTIMATED_PER_HOUR ||
    applyOn === APPLY_ON_ESTIMATED_PER_DAY ||
    applyOn === APPLY_ON_ESTIMATED_PER_PERSON
  );
};

export const isCustomCost = costType =>
  [
    COST_TYPE_CUSTOM_SERVICE,
    COST_TYPE_CUSTOM_TAX,
    COST_TYPE_CUSTOM_FEE
  ].includes(costType);
